import { FileQuestion } from "lucide-react";

export default function PlaceholderPage({ title, subtitle, testId }) {
  return (
    <div className="space-y-8" data-testid={testId || "placeholder-page"}>
      <div className="border-b border-gray-200 pb-6">
        <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
          Modul
        </div>
        <h1 className="mt-1 font-display text-3xl font-bold tracking-tight text-slate-900">
          {title}
        </h1>
        {subtitle ? (
          <p className="mt-1 text-[13px] text-slate-500">{subtitle}</p>
        ) : null}
      </div>

      <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 bg-white px-6 py-20 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-md bg-[#e8edf2] text-[#1e3a5f]">
          <FileQuestion className="h-6 w-6" strokeWidth={1.8} />
        </div>
        <div className="mt-4 text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500">
          [DATA BELUM TERSEDIA]
        </div>
        <h3 className="mt-1 font-display text-lg font-semibold text-slate-900">
          Modul ini belum aktif
        </h3>
        <p className="mt-1 max-w-md text-[12px] leading-relaxed text-slate-500">
          Fitur ini akan dikembangkan pada fase berikutnya. Saat ini sistem berada pada
          tahap fondasi, shell, dan autentikasi.
        </p>
      </div>
    </div>
  );
}
